// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale, { scaleInverse } from "../helper/scaling";

import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  padding-bottom: 30px;

  @media (max-width: 1100px) {
    padding-bottom: ${scale(1100, 767, 30, 10, "vw")};
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding: 0;
    margin: 20px 23px;
  }
`;
const Title = styled.div`
  width: 1040px;
  padding: 45px calc(50% - 520px) 50px calc(50% - 520px);
  float: left;

  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.07;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    width: calc(100% - 50px);

    padding: ${scale(1100, 767, 45, 15, "vw")} 25px
      ${scale(1100, 767, 50, 20, "vw")} 25px;
    font-size: ${scale(1100, 767, 28, 24, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 16px;
    padding: 0;
    width: 100%;
    margin-bottom: 8px;
  }
`;
const Items = styled.div`
  width: 1080px;
  float: left;
  padding: 0 calc(50% - 540px);

  @media (max-width: 1100px) {
    width: 100%;
    padding: 0;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0;
  }
`;
const Row = styled.div`
  width: 100%;
  float: left;
  padding-bottom: 35px;

  display: flex;
  justify-content: space-between;

  @media (max-width: 1100px) {
    width: ${scaleInverse(1100, 767, 10, 34, "vw")};
    padding: 0 ${scale(1100, 767, 5, 17, "vw")}
      ${scale(1100, 767, 35, 20, "vw")} ${scale(1100, 767, 5, 17, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0;
    flex-wrap: wrap;
  }
`;

class SetColumns extends Component {
  render() {
    let first = this.props.set[0];
    let rows = [];
    let col = [];
    for (let i in this.props.set) {
      if (i > 0) {
        col.push(this.props.set[i]);
        if (i % 2 === 0) {
          rows.push(col);
          col = [];
        }
      }
    }
    if (col.length > 0) rows.push(col);
    return (
      <Wrapper>
        <Title>{first.title}</Title>
        <Items>
          {rows.map((row, index) => (
            <Row key={index}>{row.map(column => <Column key={column.id} content={column} />)}</Row>
          ))}
        </Items>
      </Wrapper>
    );
  }
}

export default SetColumns;

const Item = styled.div`
  width: 50px;
  margin: 0 20px;
  flex-grow: 1;

  @media (max-width: 1100px) {
    margin: 0 ${scale(1100, 767, 20, 8, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 10px 0;
  }
`;
const ItemTitle = styled.div`
  width: 100%;
  float: left;
  padding-bottom: 15px;

  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 14, "vw")};
    padding-bottom: ${scale(1100, 767, 15, 8, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 13px;
    padding-bottom: 5px;
  }
`;
const ItemBody = styled.div`
  width: 100%;
  float: left;

  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 15, 12, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 11px;
  }
`;

class Column extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        <ItemTitle>{this.title()}</ItemTitle>
        <ItemBody>
          <FlatBody>{this.body()}</FlatBody>
        </ItemBody>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetColumns.js